<template>

    <md-menu md-size="auto" class="button-like-extended white">
        <md-button md-menu-trigger class="button-periodo s-h3">
            {{selectedItem ? selectedItem[propExibicao] : titulo}}
            <md-icon style="margin-right: 9px;">expand_less</md-icon>
        </md-button>

        <md-menu-content class="periodo-wide" v-if="Data">
            <md-menu-item style="background:#FFFFFF" v-for="c in Data" :value="c.value" @click="setSelected(c)" :key="c.value">{{c[propExibicao]}}</md-menu-item>
        </md-menu-content>
    </md-menu>



</template>

<script>
    export default {
        name: 'DropdownMenu',

        props: {
            titulo: String,
            propExibicao: String,
            propSelecao: String,
            Data: Array,
            Header: Array,
            selected: null

        },
        data() {
            return {
                selectedItem: null,
                aluno: null,
                dados: this.Data,
                headers: this.Header,
                internalChange: false
            }
        },
        methods: {
            setSelected(item) {
                this.internalChange = true
                this.selectedItem = item
                var selecsted = null;
                if (this.propSelecao) {
                    selecsted = item[this.propSelecao]
                } else {
                    selecsted = item
                }
                this.$emit('update:selected', selecsted);
            }
        },
        watch: {
            selected: function (newVal) {
                if (this.internalChange) {
                    this.internalChange = false;
                } else {
                    if (this.Data && this.propSelecao) {
                        this.selectedItem = this.Data.find(t => t[this.propSelecao] == newVal);
                    }
                }
            }
        }


    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
